module.exports = __webpack_public_path__ + "img/icon-school1.804f8056.png";